import React, { useState, useContext, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import './style.css'
import '../../styles/page-titles.css'
import PermissionGate from "../../services/PermissionGate";

import styled from 'styled-components';

import { SidebarContext } from "../../AppRoutes";

import { importCardapioAnotaai, importCardapioIfood, apiUpdateImportFlag, apiCheckImportStatus, getProgressoImportacao, getCurrentAccessToken } from '../../services/api';

// Ícones React Icons seguindo o padrão da configuração inicial
import { FaUtensils, FaExclamationCircle } from 'react-icons/fa';
import { MdRestaurantMenu } from 'react-icons/md';
import { AiOutlineCheck } from 'react-icons/ai';

import io from 'socket.io-client';
import { ProgressBar } from 'react-bootstrap';

const PageContainer = styled.div`
    display: flex;
    margin-left: ${({ $sidebar }) => ($sidebar ? '250px' : '100px')};
    min-height: 100vh;
    transition: margin-left 200ms ease;
    background: #ffffff;

    @media (max-width: 880px) {
        margin-left: 0;
    }
`;

const ContentWrapper = styled.div`
    width: 100%;
    padding: 24px;

    @media (max-width: 768px) {
        padding: 16px;
    }
`;


const ImportaCardapio = () => {
    const { t } = useTranslation('menuImport');
    const { sidebar } = useContext(SidebarContext);; //TESTANDO CONST NO AppROUTES
    const navigate = useNavigate();

    const empresa = localStorage.getItem('empresa')
    const empresaParse = JSON.parse(empresa)
    const objIdEmpresa = empresaParse._id;
    const idEmpresa = empresaParse.id_empresa;



    const [selectedImportSource, setSelectedImportSource] = useState('');
    const [showVideo, setShowVideo] = useState(false);
    const [videoType, setVideoType] = useState('');
    const [cardapioFormData, setCardapioFormData] = useState({
        ifoodLink: '',
        anotaaiLink: ''
    });

    const [importProgress, setImportProgress] = useState(null);
    const [importComplete, setImportComplete] = useState(false);
    const [importMessage, setImportMessage] = useState('');
    const [importStage, setImportStage] = useState('');
    const [importDetails, setImportDetails] = useState({});
    const [isImporting, setIsImporting] = useState(false);
    const [loading, setLoading] = useState(false);


    const isDevelopment = window.location.hostname === 'localhost';
    const apiUrl = isDevelopment
        ? process.env.REACT_APP_SERVER_URL_DEV
        : process.env.REACT_APP_SERVER_URL_PROD;

    // Verificar progresso da importação salvo
    const checkImportProgress = useCallback(async () => {
        try {
            const response = await getProgressoImportacao(idEmpresa);
            const { importacao_finalizada, progresso_importacao } = response.data;

            if (importacao_finalizada) {
                setImportComplete(true);
                setImportProgress(100);
                setImportMessage(t('progress.successMessage'));
                setImportStage('finalizado');
                setIsImporting(false);
            } else if (progresso_importacao && progresso_importacao.em_andamento) {
                setImportProgress(progresso_importacao.porcentagem);
                setImportMessage(progresso_importacao.etapa_atual);
                setImportStage('em_andamento');
                setIsImporting(true);
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao verificar progresso da importação:", error);
        }
    }, [idEmpresa, t]);

    // Refatorando a função checkImportStatus
    const checkImportStatus = useCallback(async () => {
        try {
            const response = await apiCheckImportStatus(idEmpresa);
            const data = response.data; // assumindo que está usando axios, onde a resposta está no campo `data`

            if (data.importacao_finalizada) {
                setImportComplete(true);
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao verificar status de importação:", error);
        }
    }, [idEmpresa]);

    const updateImportFlag = useCallback(async () => {
        try {
            const importacao_finalizada = true;
            // ✅ V2 não precisa de idEmpresa - usa req.context automaticamente
            await apiUpdateImportFlag(importacao_finalizada)
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao atualizar flag de importação:", error);
        }
    }, []);

    useEffect(() => {
        // Conectar ao servidor WebSocket
        const wsUrl = apiUrl;
        const newSocket = io(wsUrl, {
            withCredentials: true,
            transports: ['websocket'],
            auth: { token: getCurrentAccessToken() }
        });

        // Entrar na sala da empresa
        newSocket.emit('joinCompanyRoom', {
            companyId: objIdEmpresa.toString(),
            clientId: 'importClient'
        });

        // Escutar eventos de progresso da importação
        newSocket.on('import-progress', (data) => {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Progresso recebido:", data);
            setImportProgress(data.progress);
            setImportMessage(data.message || '');
            setImportStage(data.stage || '');
            setImportDetails(data.details || {});
            setIsImporting(data.progress < 100);

            if (data.progress === 100 && data.stage === 'finalizado') {
                setImportComplete(true);
                setIsImporting(false);
                updateImportFlag();
            }

            if (data.stage === 'erro') {
                setImportProgress(null);
                setImportMessage('');
                setImportStage('erro');
                setIsImporting(false);
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro durante importação:', data.message);
            }
        });

        //setSocket(newSocket);

        // Verificar status/progresso ao carregar
        checkImportStatus();
        checkImportProgress();

        // Cleanup quando o componente desmontar
        return () => {
            newSocket.off('import-progress');
            newSocket.disconnect();
        };
    }, [apiUrl, checkImportProgress, checkImportStatus, objIdEmpresa, updateImportFlag]);


    // Funções para lidar com a importação
    const handleImportCardapio = async (source, link) => {
        if (!link) return;

        try {
            setIsImporting(true);
            setLoading(true);
            setImportStage('');
            setImportProgress(0);

            if (source === 'ifood') {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Caiu no import Ifood");
                const response = await importCardapioIfood(link, idEmpresa);
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("RESPOSTA Ifood:", response);
            } else if (source === 'anotaai') {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Caiu no import AnotaAi");
                const response = await importCardapioAnotaai(link, idEmpresa);
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("RESPOSTA AnotaAi:", response);
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro durante o import:", error);
            setImportStage('erro');
            setIsImporting(false);
        } finally {
            setLoading(false);
        }
    };

    const handleResetImportStatus = () => {
        setImportProgress(null);
        setImportComplete(false);
        setImportMessage('');
        setImportStage('');
        setImportDetails({});
        setIsImporting(false);
        setCardapioFormData({ ifoodLink: '', anotaaiLink: '' });
    };

    const handleFinishCardapioImport = () => {
        // Navegar para próxima página ou fechar modal
        navigate('/'); // ou qualquer rota apropriada
    };




    return (
        <PermissionGate permissions={['default']}>
            <PageContainer $sidebar={sidebar}>
                <ContentWrapper>
                    <div className="page-title-with-subtitle">
                        <div className="page-title-with-icon">
                            <div className="page-icon"><MdRestaurantMenu /></div>
                            <h1 className="page-title">{t('pageTitle')}</h1>
                        </div>
                        <p className="page-subtitle">{t('pageSubtitle', 'Importe seu cardapio de outras plataformas')}</p>
                    </div>

                        <div className="menu-import-container">
                            <div className="menu-import-step-icon">
                                <MdRestaurantMenu />
                            </div>
                            <h3>🍽️ {t('pageTitle')}</h3>
                            <p>{t('pageSubtitle')}</p>

                            {/* Banner informativo */}
                            <div className="menu-import-info-banner">
                                <div className="menu-import-info-content">
                                    <span className="menu-import-info-icon">💡</span>
                                    <div>
                                        <strong>{t('infoBanner.title')}</strong>
                                        <p>{t('infoBanner.description')}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Estado de importação completa */}
                            {importComplete ? (
                                <div className="menu-import-success-final">
                                    <AiOutlineCheck className="menu-import-success-icon-large" />
                                    <h3>{t('success.title')}</h3>
                                    <p>{t('success.description')}</p>
                                    <button
                                        type="button"
                                        onClick={handleFinishCardapioImport}
                                        className="menu-import-btn-finish"
                                    >
                                        {t('success.finishButton')}
                                    </button>
                                </div>
                            ) :

                                /* Estado de progresso da importação */
                                ((importProgress !== null && importProgress < 100) || isImporting) ? (
                                    <div className="menu-import-progress">
                                        <div className="menu-import-progress-info">
                                            <span className="menu-import-progress-message">
                                                {importMessage || t('progress.importing')}
                                            </span>
                                            <span className="menu-import-progress-percentage">
                                                {importProgress !== null ? `${importProgress}%` : '0%'}
                                            </span>
                                        </div>
                                        <ProgressBar
                                            now={importProgress || 0}
                                            animated={isImporting}
                                            variant="success"
                                            style={{ height: '25px', marginBottom: '10px' }}
                                        />
                                        {importDetails && importStage === 'categorias' && (
                                            <div className="menu-import-progress-details">
                                                <small>
                                                    📋 {t('progress.processingCategory')} <strong>{importDetails.categoria_atual}</strong>
                                                    <br />
                                                    ({importDetails.categorias_processadas}/{importDetails.total_categorias})
                                                </small>
                                            </div>
                                        )}
                                        {importDetails && importStage === 'itens' && (
                                            <div className="menu-import-progress-details">
                                                <small>
                                                    🍽️ {t('progress.processingItems')} <strong>{importDetails.categoria_atual}</strong>
                                                    <br />
                                                    ({importDetails.itens_processados}/{importDetails.total_itens})
                                                </small>
                                            </div>
                                        )}
                                        {importDetails && importStage === 'adicionais' && (
                                            <div className="menu-import-progress-details">
                                                <small>
                                                    ➕ {t('progress.processingGroup')} <strong>{importDetails.grupo_atual}</strong>
                                                    <br />
                                                    ({importDetails.grupos_processados}/{importDetails.total_grupos})
                                                </small>
                                            </div>
                                        )}
                                    </div>
                                ) :

                                    /* Interface principal de importação */
                                    (
                                        <div className="menu-import-section">
                                            <h4>📥 {t('selectPlatform.title')}</h4>
                                            <p>{t('selectPlatform.description')}</p>

                                            {/* Switch para escolher fonte de importação */}
                                            <div className="menu-import-source-switch">
                                                <div className="menu-import-switch-buttons">
                                                    <button
                                                        type="button"
                                                        onClick={() => setSelectedImportSource('ifood')}
                                                        className={`menu-import-switch-btn ${selectedImportSource === 'ifood' ? 'active' : ''}`}
                                                    >
                                                        <FaUtensils className="menu-import-switch-icon ifood" />
                                                        {t('platforms.ifood')}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => setSelectedImportSource('anotaai')}
                                                        className={`menu-import-switch-btn ${selectedImportSource === 'anotaai' ? 'active' : ''}`}
                                                    >
                                                        <FaUtensils className="menu-import-switch-icon anotaai" />
                                                        {t('platforms.anotaai')}
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Opção de importação selecionada */}
                                            <div className="menu-import-option-selected">
                                                {selectedImportSource === 'ifood' && (
                                                    <div className="menu-import-option">
                                                        <div className="menu-import-header">
                                                            <FaUtensils className="menu-import-icon ifood" />
                                                            <span>{t('ifoodImport.title')}</span>
                                                        </div>
                                                        <div className="menu-import-form">
                                                            <label>{t('ifoodImport.linkLabel')}</label>
                                                            <input
                                                                type="text"
                                                                placeholder={t('ifoodImport.linkPlaceholder')}
                                                                value={cardapioFormData.ifoodLink}
                                                                onChange={(e) => setCardapioFormData(prev => ({ ...prev, ifoodLink: e.target.value }))}
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setShowVideo(true);
                                                                    setVideoType('ifood');
                                                                }}
                                                                className="menu-import-help-link"
                                                            >
                                                                {t('ifoodImport.helpLink')}
                                                            </button>

                                                            {importStage === 'erro' && (
                                                                <div className="menu-import-error">
                                                                    <div className="menu-import-error-info">
                                                                        <FaExclamationCircle className="menu-import-error-icon" />
                                                                        <span>{t('error.importError')}</span>
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        onClick={handleResetImportStatus}
                                                                        disabled={loading}
                                                                        className="menu-import-btn-reset"
                                                                    >
                                                                        {loading ? t('error.resetting') : t('error.resetButton')}
                                                                    </button>
                                                                </div>
                                                            )}

                                                            <button
                                                                type="button"
                                                                onClick={() => handleImportCardapio('ifood', cardapioFormData.ifoodLink)}
                                                                disabled={!cardapioFormData.ifoodLink || isImporting}
                                                                className="menu-import-btn"
                                                            >
                                                                {isImporting ? t('ifoodImport.importingButton') : t('ifoodImport.importButton')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}

                                                {selectedImportSource === 'anotaai' && (
                                                    <div className="menu-import-option">
                                                        <div className="menu-import-header">
                                                            <FaUtensils className="menu-import-icon anotaai" />
                                                            <span>{t('anotaaiImport.title')}</span>
                                                        </div>
                                                        <div className="menu-import-form">
                                                            <label>{t('anotaaiImport.linkLabel')}</label>
                                                            <input
                                                                type="text"
                                                                placeholder={t('anotaaiImport.linkPlaceholder')}
                                                                value={cardapioFormData.anotaaiLink}
                                                                onChange={(e) => setCardapioFormData(prev => ({ ...prev, anotaaiLink: e.target.value }))}
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setShowVideo(true);
                                                                    setVideoType('anotaai');
                                                                }}
                                                                className="menu-import-help-link"
                                                            >
                                                                {t('anotaaiImport.helpLink')}
                                                            </button>

                                                            {importStage === 'erro' && (
                                                                <div className="menu-import-error">
                                                                    <div className="menu-import-error-info">
                                                                        <FaExclamationCircle className="menu-import-error-icon" />
                                                                        <span>{t('error.importError')}</span>
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        onClick={handleResetImportStatus}
                                                                        disabled={loading}
                                                                        className="menu-import-btn-reset"
                                                                    >
                                                                        {loading ? t('error.resetting') : t('error.resetButton')}
                                                                    </button>
                                                                </div>
                                                            )}

                                                            <button
                                                                type="button"
                                                                onClick={() => handleImportCardapio('anotaai', cardapioFormData.anotaaiLink)}
                                                                disabled={!cardapioFormData.anotaaiLink || isImporting}
                                                                className="menu-import-btn"
                                                            >
                                                                {isImporting ? t('anotaaiImport.importingButton') : t('anotaaiImport.importButton')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Modal de vídeo */}
                                            {showVideo && (
                                                <div className="menu-import-video-overlay" onClick={() => setShowVideo(false)}>
                                                    <div className="menu-import-video-content" onClick={(e) => e.stopPropagation()}>
                                                        <div className="menu-import-video-header">
                                                            <h4>{t('videoModal.title', { platform: videoType === 'ifood' ? 'iFood' : 'AnotaAí' })}</h4>
                                                            <button
                                                                className="menu-import-video-close"
                                                                onClick={() => setShowVideo(false)}
                                                            >
                                                                ×
                                                            </button>
                                                        </div>
                                                        <div className="menu-import-video-body">
                                                            <p>{t('videoModal.comingSoon')}</p>
                                                            <div className="menu-import-video-placeholder">
                                                                <FaUtensils className="menu-import-video-icon" />
                                                                <p>{t('videoModal.tutorial', { platform: videoType === 'ifood' ? 'iFood' : 'AnotaAí' })}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                        </div>
                </ContentWrapper>
            </PageContainer>
        </PermissionGate>
    )
}

export default ImportaCardapio;